function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/* eslint camelcase: 0 */

import * as React from 'react';
import { clsx } from 'clsx';
import isEmpty from 'lodash/isEmpty';
import { SECONDS_BY_UNIT } from 'common/util/date';
import { NAVIGATION_KEY_CODES } from 'common/util/dom';
import { withStyles } from 'common/util/react';
import { FunnelOrder, FunnelReentryModeType, FUNNELS_MATH_TYPES } from 'common/types/reports/bookmark';
import { CONVERSION_WINDOW_TOOLTIP, EXCLUSION_EVENTS_TOOLTIP, HOLD_PROPERTY_CONSTANT_DISABLED_TOOLTIP, HOLD_PROPERTY_CONSTANT_TOOLTIP, OPTIMIZED_REENTRY_TOOLTIP, ORDER_OPTIONS } from 'common/report/funnels/models/constants';
import { CountType } from 'common/report/funnels/models/types';
import { getCountTypeSections } from 'common/query-builder/util/query-options';
import { IncludeCustomPropertyType, PropertyCombineMode } from 'common/query-builder/query-block/properties-menu/types';
import { EntrySectionUpdates, EntryType, QueryEventEntry, QuerySegmentEntry, RowLabelType, SelectorTypeDefinitions } from 'common/query-builder/query-entry-section/types';
// eslint-disable-next-line import/no-cycle
import { QueryEntrySectionReact } from 'common/query-builder/query-entry-section';
import { sanitizeExclusionSteps } from 'common/query-builder/query-builder/util';
import { ChangeEvent, MenuChangeEvent } from 'common/components/select/types';
import { ButtonBarReact } from 'common/components/button-bar';
import { ButtonSize } from 'common/components/button/constants';
import { Directions } from 'common/components/drop-menu/types';
import { InputReact } from 'common/components/input';
import { SectionReact } from 'common/components/section';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { SwitchChangeEvent, SwitchEl } from 'common/components/switch';
import { Placement } from 'common/components/tooltip/types';
import { StickyPlaceholderReact } from 'common/widgets/sticky-placeholder';
import { IronContextRegistry } from 'common/report/context-registry';
import { Translatable } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { Section } from 'common/components/items-menu/types';
import { isFunnelReentryOptionsEnabled } from 'common/report/util/feature-sampling';
import { currentProjectStore } from 'common/report/stores/project-details';
import { QueryEntrySectionTrackingEvent } from 'common/query-builder/query-entry-section/tracking';
import { ConversionCriteriaAction, QueryOptionsProps, QueryOptionsState } from './types';
// eslint-disable-next-line import/no-cycle
import { TrackedEvents } from './tracking';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
class ConversionQueryOptions extends React.PureComponent<QueryOptionsProps & Pick<IronContextRegistry, `i18n`>, QueryOptionsState> {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    _defineProperty(this, "stickyHeaderRef", React.createRef<HTMLDivElement>());
    _defineProperty(this, "state", {
      conversionWindowErrorMsg: null,
      isConversionWindowMenuOpen: false,
      isConversionWindowMenuHovered: false,
      isCountTypeMenuOpen: false,
      isCountTypeMenuHovered: false,
      selectedValue: 7,
      selectedUnit: "day",
      holdingPropertyConstant: [],
      stageHoldProps: false,
      stageExclusionSteps: false
    });
    _defineProperty(this, "handleOptionsChange", function () {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this.props.onChangeQueryOption(_objectSpread(_objectSpread({}, _this.props.selected), options));
      if ("funnelReentryMode" in options) {
        var _this$props$onTrack, _this$props;
        (_this$props$onTrack = (_this$props = _this.props).onTrack) === null || _this$props$onTrack === void 0 || _this$props$onTrack.call(_this$props, {
          eventName: QueryEntrySectionTrackingEvent.FunnelReentryModeToggled,
          properties: {
            funnelReentryMode: options.funnelReentryMode
          }
        });
      }
    });
    _defineProperty(this, "applyConversionWindowSelections", () => {
      var _this$props$onTrack2, _this$props2;
      const {
        selectedValue,
        selectedUnit
      } = this.state;
      this.handleOptionsChange({
        conversionWindow: {
          value: selectedValue,
          unit: selectedUnit
        }
      });
      (_this$props$onTrack2 = (_this$props2 = this.props).onTrack) === null || _this$props$onTrack2 === void 0 || _this$props$onTrack2.call(_this$props2, {
        eventName: TrackedEvents.EditConversionWindow,
        properties: _objectSpread({
          Unit: selectedUnit,
          Value: selectedValue
        }, this.props.selected.countType === CountType.Session ? {} : {
          'Unit in seconds': selectedValue * SECONDS_BY_UNIT[selectedUnit]
        })
      });
      this.setState({
        isConversionWindowMenuOpen: false,
        isConversionWindowMenuHovered: false
      });
    });
    _defineProperty(this, "handleKeyStroke", ev => {
      if (ev.keyCode === NAVIGATION_KEY_CODES.ENTER && !this.state.conversionWindowErrorMsg) {
        this.applyConversionWindowSelections();
      }
    });
    _defineProperty(this, "handleCountTypeChange", (ev: ChangeEvent) => {
      const {
        value: countType,
        isSelected
      } = ev.detail.item;
      if (!isSelected) {
        var _this$props$onTrack3, _this$props3;
        const prevCountType = this.props.selected.countType;
        let conversionWindowUpdates = {};
        if ([CountType.Unique, CountType.General].includes(prevCountType) && countType === CountType.Session) {
          conversionWindowUpdates = {
            value: 1,
            unit: "session"
          };
        } else if (CountType.Session === prevCountType && [CountType.Unique, CountType.General].includes(countType)) {
          conversionWindowUpdates = {
            value: 7,
            unit: "day"
          };
        }
        this.handleOptionsChange(_objectSpread({
          countType
        }, isEmpty(conversionWindowUpdates) ? {} : {
          conversionWindow: conversionWindowUpdates
        }));
        (_this$props$onTrack3 = (_this$props3 = this.props).onTrack) === null || _this$props$onTrack3 === void 0 || _this$props$onTrack3.call(_this$props3, {
          eventName: TrackedEvents.EditCounts,
          properties: _objectSpread({
            'Count type': countType,
            'Previous count type': prevCountType
          }, isEmpty(conversionWindowUpdates) ? {} : {
            'Conversion window unit': conversionWindowUpdates["unit"],
            'Conversion window value': conversionWindowUpdates["value"]
          })
        });
      }
      this.setState({
        isCountTypeMenuOpen: false,
        isCountTypeMenuHovered: false
      });
    });
    _defineProperty(this, "handleConversionWindowValueChange", ev => {
      const newValue = parseInt(ev.target.value, 10);
      this.setState({
        conversionWindowErrorMsg: this.validateConversionWindow(newValue, this.state.selectedUnit),
        selectedValue: newValue
      });
    });
    _defineProperty(this, "handleConversionWindowUnitChange", ev => {
      const {
        value: newUnit,
        isSelected
      } = ev.detail.item;
      if (!isSelected) {
        const value = this.state.selectedValue;
        const conversionWindowErrorMsg = this.validateConversionWindow(value, newUnit);
        this.setState({
          conversionWindowErrorMsg,
          selectedUnit: newUnit
        });
      }
    });
    _defineProperty(this, "getConversionWindowSections", (): Section[] => {
      const showSessions = this.props.showSessions;
      const options = this.props.conversionWindowUnits.filter(value => value === CountType.Session ? showSessions : true);
      const labels: Record<string, (count: number) => Translatable> = {
        second: count => _ref => {
          let {
            t
          } = _ref;
          return t("reports.time-unit.second", {
            count
          });
        },
        minute: count => _ref2 => {
          let {
            t
          } = _ref2;
          return t("reports.time-unit.minute", {
            count
          });
        },
        hour: count => _ref3 => {
          let {
            t
          } = _ref3;
          return t("reports.time-unit.hour", {
            count
          });
        },
        day: count => _ref4 => {
          let {
            t
          } = _ref4;
          return t("reports.time-unit.day", {
            count
          });
        },
        week: count => _ref5 => {
          let {
            t
          } = _ref5;
          return t("reports.time-unit.week", {
            count
          });
        },
        month: count => _ref6 => {
          let {
            t
          } = _ref6;
          return t("reports.time-unit.month", {
            count
          });
        },
        session: count => _ref7 => {
          let {
            t
          } = _ref7;
          return t("reports.time-unit.session", {
            count
          });
        }
      };
      return [{
        items: options.map(unit => ({
          value: unit,
          label: labels[unit] ? this.props.i18n.print(labels[unit](this.state.selectedValue)).toLowerCase() : unit,
          isSelected: unit === this.state.selectedUnit
        }))
      }];
    });
    _defineProperty(this, "handleConversionWindowMenuChange", (ev: MenuChangeEvent) => {
      const countType = this.props.selected.countType;
      if (countType === CountType.Session) {
        return;
      }
      if (!ev.detail.isOpen) {
        const {
          value: selectedValue,
          unit: selectedUnit
        } = this.props.selected.conversionWindow;
        this.setState({
          conversionWindowErrorMsg: null,
          isConversionWindowMenuOpen: false,
          selectedValue,
          selectedUnit
        });
      } else {
        this.setState({
          isConversionWindowMenuOpen: true
        });
      }
    });
    _defineProperty(this, "handleConversionWindowMenuMouseEnter", () => {
      this.setState({
        isConversionWindowMenuHovered: true
      });
    });
    _defineProperty(this, "handleConversionWindowMenuMouseLeave", () => {
      this.setState({
        isConversionWindowMenuHovered: false
      });
    });
    _defineProperty(this, "handleCountTypeMenuChange", (ev: MenuChangeEvent) => {
      this.setState({
        isCountTypeMenuOpen: ev.detail.isOpen
      });
    });
    _defineProperty(this, "handleCountTypeMenuMouseEnter", () => {
      this.setState({
        isCountTypeMenuHovered: true
      });
    });
    _defineProperty(this, "handleCountTypeMenuMouseLeave", () => {
      this.setState({
        isCountTypeMenuHovered: false
      });
    });
    _defineProperty(this, "handleExclusionEventsUpdate", (_ref8: EntrySectionUpdates<QueryEventEntry>) => {
      let {
        entries
      }: EntrySectionUpdates<QueryEventEntry> = _ref8;
      this.handleOptionsChange({
        exclusionSteps: sanitizeExclusionSteps(entries, this.props.builderParams.entriesCount)
      });
      this.setState({
        stageExclusionSteps: false
      });
    });
    /**
     * Transforms Segmentation[] entries into properties
     * @todo [pablo] update this in favor of a property selector type
     */
    _defineProperty(this, "handlePropertyConstantUpdate", (_ref9: EntrySectionUpdates<QuerySegmentEntry>) => {
      let {
        entries
      }: EntrySectionUpdates<QuerySegmentEntry> = _ref9;
      const properties = entries.map(entry => entry.event);
      this.handleOptionsChange({
        holdingPropertyConstant: properties
      });
      this.setState({
        stageHoldProps: false
      });
    });
    _defineProperty(this, "handleConversionCriteriaAdd", (ev: ChangeEvent) => {
      const {
        value
      } = ev.detail.item;
      if (value === ConversionCriteriaAction.ExcludeEvent) {
        this.setState({
          stageExclusionSteps: true
        });
      } else if (value === ConversionCriteriaAction.HoldProperty) {
        this.setState({
          stageHoldProps: true
        });
      }
    });
  }
  componentDidMount() {
    this.setState({
      selectedUnit: this.props.selected.conversionWindow.unit,
      selectedValue: this.props.selected.conversionWindow.value,
      holdingPropertyConstant: this.props.selected.holdingPropertyConstant
    });
  }
  componentDidUpdate(prevProps) {
    const {
      conversionWindow: {
        unit: selectedUnit,
        value: selectedValue
      },
      holdingPropertyConstant
    } = this.props.selected;
    const {
      conversionWindow: {
        unit: prevSelectedUnit,
        value: prevSelectedValue
      },
      holdingPropertyConstant: prevHoldingPropertyConstant
    } = prevProps.selected;
    if (selectedUnit !== prevSelectedUnit || selectedValue !== prevSelectedValue) {
      this.setState({
        selectedUnit,
        selectedValue
      });
    }

    // Reset holding property constant when prop-provided value changes
    if (holdingPropertyConstant.length !== prevHoldingPropertyConstant.length || holdingPropertyConstant.some((property, index) => property.propertyName !== prevHoldingPropertyConstant[index].propertyName)) {
      this.setState({
        holdingPropertyConstant
      });
    }
  }

  /**
   * Ensure the conversion window inputs are valid.
   * @param value - conversion window length (e.g. 7)
   * @param unit - conversion window unit (e.g. day/week)
   * @return error message if conversion window input is invalid, null otherwise
   */
  validateConversionWindow(value: number, unit: string): string | null {
    let error = null;
    if (Number.isNaN(value)) {
      error = "Input must be an integer";
    } else if (value < this.props.conversionWindowSizeLimits[unit].MIN) {
      error = "Conversion window below ".concat(this.props.conversionWindowSizeLimits[unit].MIN, " ").concat(unit, " minimum");
    } else if (value > this.props.conversionWindowSizeLimits[unit].MAX) {
      error = "Conversion window exceeds ".concat(this.props.conversionWindowSizeLimits[unit].MAX, " ").concat(unit, " maximum");
    }
    return error;
  }
  getConversionCriteriaSections(): Section[] {
    const holdingPropertyConstantLimitReached = this.state.holdingPropertyConstant.length >= this.props.maxHoldingPropertyConstant;
    return [{
      items: [...(!this.props.hideFunnelsOnlyOptions ? [{
        isDisabled: this.props.disableAnyOrderMessage !== "",
        label: _ref10 => {
          let {
            t
          } = _ref10;
          return t("query-builder.conversion.any-order");
        },
        icon: "top-paths",
        tooltip: this.props.disableAnyOrderMessage ? {
          text: this.props.disableAnyOrderMessage
        } : ORDER_OPTIONS.find(order => this.props.selected.funnelOrder === order.value).tooltip,
        actionsRenderer: () => SwitchEl({
          attrs: {
            on: this.props.selected.funnelOrder === FunnelOrder.Any && this.props.disableAnyOrderMessage === ""
          },
          on: {
            change: (_ref11: SwitchChangeEvent) => {
              let {
                detail: {
                  on
                }
              }: SwitchChangeEvent = _ref11;
              return this.handleOptionsChange({
                funnelOrder: on ? FunnelOrder.Any : FunnelOrder.Loose
              });
            }
          }
        })
      }] : []), ...(!this.props.hideFunnelsOnlyOptions && isFunnelReentryOptionsEnabled(currentProjectStore === null || currentProjectStore === void 0 ? void 0 : currentProjectStore.value) ? [{
        isDisabled: false,
        label: _ref12 => {
          let {
            t
          } = _ref12;
          return t("query-builder.conversion.optimized-reentry");
        },
        icon: "merge",
        tooltip: OPTIMIZED_REENTRY_TOOLTIP,
        actionsRenderer: () => SwitchEl({
          attrs: {
            on: this.props.selected.funnelReentryMode === FunnelReentryModeType.Optimized
          },
          on: {
            change: (_ref13: SwitchChangeEvent) => {
              let {
                detail: {
                  on
                }
              }: SwitchChangeEvent = _ref13;
              return this.handleOptionsChange({
                funnelReentryMode: on ? FunnelReentryModeType.Optimized : FunnelReentryModeType.Basic
              });
            }
          }
        })
      }] : []), {
        icon: "eye-hide",
        label: _ref14 => {
          let {
            t
          } = _ref14;
          return t("query-builder.conversion.exclude-who-did");
        },
        value: ConversionCriteriaAction.ExcludeEvent,
        tooltip: EXCLUSION_EVENTS_TOOLTIP
      }, {
        icon: "lock",
        label: _ref15 => {
          let {
            t
          } = _ref15;
          return t("query-builder.conversion.hpc");
        },
        value: ConversionCriteriaAction.HoldProperty,
        tooltip: holdingPropertyConstantLimitReached ? HOLD_PROPERTY_CONSTANT_DISABLED_TOOLTIP : HOLD_PROPERTY_CONSTANT_TOOLTIP,
        isDisabled: holdingPropertyConstantLimitReached
      }]
    }];
  }
  render() {
    var _builderParams$exclus, _builderParams$exclus2, _builderParams$exclus3, _builderParams$exclus4, _this$props$selected;
    const {
      conversionWindowErrorMsg,
      isConversionWindowMenuOpen,
      isConversionWindowMenuHovered,
      isCountTypeMenuOpen,
      isCountTypeMenuHovered,
      selectedValue
    } = this.state;
    const {
      t
    } = this.props.i18n;
    const builderParams = this.props.builderParams;
    const isSticky = this.props.enableStickyHeader;
    const selectedCountType = this.props.selected.countType;
    const isConversionWindowDisabled = selectedCountType === CountType.Session || selectedCountType as any === FUNNELS_MATH_TYPES.CONVERSION_RATE_SESSION;
    return <div className={styles.conversionQueryOptionsWrapper} data-sentry-component="ConversionQueryOptions" data-sentry-source-file="index.tsx">
        {isSticky && <StickyPlaceholderReact className={styles.stickyPlaceholder} stickyElm={this.stickyHeaderRef.current} />}
        <div ref={this.stickyHeaderRef} className={clsx(styles.conversionCriteriaHeader, {
        [styles.isSticky]: isSticky
      })}>
          <SectionReact className={styles.section} headerTitle={t("query-builder.conversion-criteria")} nonCollapsible data-sentry-element="SectionReact" data-sentry-source-file="index.tsx">
            <SelectReact slot={"actions"} theme={SelectTheme.Tertiary} alwaysShowCaret selectedOption={t("query-builder.advanced")} menuAlignment={Directions.Right} menuWidth={245} size={ButtonSize.Small} tooltip={{
            placement: Placement.Right
          }} experimentalPositioning onChange={this.handleConversionCriteriaAdd} sections={this.getConversionCriteriaSections()} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx" />
          </SectionReact>
        </div>
        <SectionReact className={styles.section} nonCollapsible isClosed={this.props.hideConversionWindow} data-sentry-element="SectionReact" data-sentry-source-file="index.tsx">
          <SelectReact className={styles.conversionWindowSelect} elref={"conversionWindowSelect"} alwaysShowCaret={this.props.selected.countType !== CountType.Session && (isConversionWindowMenuHovered || isConversionWindowMenuOpen)} disabled={isConversionWindowDisabled} theme={SelectTheme.Tertiary} open={isConversionWindowMenuOpen} selectedOption={t("query-builder.conversion-window-label.".concat(this.props.selected.conversionWindow.unit), {
          count: this.props.selected.conversionWindow.value
        })} tooltip={_objectSpread(_objectSpread({}, CONVERSION_WINDOW_TOOLTIP), {}, {
          placement: Placement.Right
        })} icon={{
          leftIcon: "stop-watch",
          rightIcon: "double-caret"
        }} onMenuChange={this.handleConversionWindowMenuChange} onMouseEnter={this.handleConversionWindowMenuMouseEnter} onMouseLeave={this.handleConversionWindowMenuMouseLeave} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx">
            <div slot={"body"}>
              {isConversionWindowMenuOpen ? <>
                  <div className={styles.conversionWindowMenu}>
                    <h4 className={styles.conversionWindowMenuTitle}>{t("query-builder.conversion-window")}</h4>
                    <p className={styles.conversionWindowMenuDescription}>
                      {t("query-builder.conversion-window-description")}
                    </p>
                    <InputReact className={clsx(styles.conversionWindowValueInput, {
                  error: !!conversionWindowErrorMsg
                })} role={"input"} type={"number"} size={"medium"} value={"".concat(selectedValue)} validationStatus={conversionWindowErrorMsg ? "invalid" : ""} errorMessage={conversionWindowErrorMsg} onChange={ev => ev.stopPropagation()} onInput={this.handleConversionWindowValueChange} onKeyUp={this.handleKeyStroke} autoFocus selectOnFocus />
                    <SelectReact elref='conversionWindowUnit' className={styles.conversionWindowUnitSelector} sections={this.getConversionWindowSections()} onChange={this.handleConversionWindowUnitChange} />
                  </div>
                  <ButtonBarReact elref='applyButton' className={"mp-button-bar-primary"} disabled={!!conversionWindowErrorMsg} tabIndex={0} onClick={this.applyConversionWindowSelections}>
                    {t("query-builder.apply")}
                  </ButtonBarReact>
                </> : null}
            </div>
          </SelectReact>
        </SectionReact>
        <SectionReact className={styles.section} nonCollapsible data-sentry-element="SectionReact" data-sentry-source-file="index.tsx">
          {!this.props.hideCountSelector && <SelectReact className={styles.conversionQueryOptionsCountType} elref={"countTypeSelect"} alwaysShowCaret={isCountTypeMenuHovered || isCountTypeMenuOpen} menuWidth={100} tabIndex={0} open={isCountTypeMenuOpen} sections={getCountTypeSections(this.props.selected.countType, this.props.showSessions)} theme={SelectTheme.Tertiary} icon={{
          leftIcon: "column-select",
          rightIcon: "double-caret"
        }} tooltip={{
          placement: Placement.Right
        }} onMenuChange={this.handleCountTypeMenuChange} onChange={this.handleCountTypeChange} onMouseEnter={this.handleCountTypeMenuMouseEnter} onMouseLeave={this.handleCountTypeMenuMouseLeave} />}
        </SectionReact>

        {/* exclusion steps */}
        <QueryEntrySectionReact className={clsx(styles.queryEntrySection, {
        [styles.isEmpty]: ((_builderParams$exclus = builderParams.exclusionSteps) === null || _builderParams$exclus === void 0 ? void 0 : _builderParams$exclus.length) === 0
      })} dataGroupId={builderParams.dataGroupId} dataGroupsEnabled={builderParams.dataGroupsEnabled} projectHasPeople={builderParams.projectHasPeople} projectHasCohorts={builderParams.projectHasCohorts} projectId={builderParams.projectId} workspaceId={builderParams.workspaceId} trackName={builderParams.trackName} projectAsOfDate={builderParams.projectAsOfDate} entries={(_builderParams$exclus2 = (_builderParams$exclus3 = builderParams.exclusionSteps) === null || _builderParams$exclus3 === void 0 ? void 0 : _builderParams$exclus3.map(step => _objectSpread(_objectSpread({}, step), {}, {
        prefixLabel: "Exclude "
      }))) !== null && _builderParams$exclus2 !== void 0 ? _builderParams$exclus2 : []} rowDraggable rowLabelType={RowLabelType.None} entryType={EntryType.ExclusionEvent} includeCustomProperties={IncludeCustomPropertyType.All} showBorrowedProperties disableAddEntry numExclusionSteps={builderParams.entriesCount} rowLabelTypeForExclusionSteps={builderParams.entryRowLabelType} trackProperties={{
        sectionName: "exclusion-steps"
      }} stagingRow={this.state.stageExclusionSteps} onAbortStage={() => this.setState({
        stageExclusionSteps: false
      })} onUpdate={this.handleExclusionEventsUpdate} data-sentry-element="QueryEntrySectionReact" data-sentry-source-file="index.tsx" />

        {/* @todo [pablo] we are using a segmentation entry section here as a temporal
         * solution  as we move towards merging filters + segments and creating a new property selector type *
         */}
        <QueryEntrySectionReact className={clsx(styles.queryEntrySection, {
        [styles.isEmpty]: ((_builderParams$exclus4 = builderParams.exclusionSteps) === null || _builderParams$exclus4 === void 0 ? void 0 : _builderParams$exclus4.length) === 0
      })} projectId={builderParams.projectId} workspaceId={builderParams.workspaceId} trackName={builderParams.trackName} rowLimit={this.props.maxHoldingPropertyConstant} rowDraggable rowLabelType={RowLabelType.None} includeCustomProperties={IncludeCustomPropertyType.All} showBorrowedProperties disableAddEntry disableMapToLookupTable eventNames={this.props.eventNames} propertyCombineMode={PropertyCombineMode.Intersection} rowTypes={[SelectorTypeDefinitions.Segment]} trackProperties={{
        'for hold property constant': true,
        sectionName: "hold-prop-constant"
      }} entries={((_this$props$selected = this.props.selected) === null || _this$props$selected === void 0 ? void 0 : _this$props$selected.holdingPropertyConstant.map(prop => ({
        type: SelectorTypeDefinitions.Segment,
        event: prop,
        filters: [],
        prefixLabel: "Hold constant "
      }))) as QuerySegmentEntry[]} stagingRow={this.state.stageHoldProps} onAbortStage={() => this.setState({
        stageHoldProps: false
      })} onUpdate={this.handlePropertyConstantUpdate} data-sentry-element="QueryEntrySectionReact" data-sentry-source-file="index.tsx" />
      </div>;
  }
}
export const ConversionQueryOptionsReact = withStyles((props: QueryOptionsProps) => {
  const i18n = useTranslation();
  return <ConversionQueryOptions i18n={i18n} {...props} />;
}, css);